/**
 * Shop-Typografie — Grundwerte (H1/H2/H3/Text) für öffentliche Shop-Seiten.
 * Presets = 1-Klick-Textbild, optionale Einzelwerte überschreiben das Preset.
 */
export const TYPO_PRESETS = {
  compact: { label: 'Kompakt', h1: 32, h2: 24, h3: 19, body: 15 },
  standard: { label: 'Standard', h1: 40, h2: 30, h3: 22, body: 17 },
  large: { label: 'Gross', h1: 52, h2: 36, h3: 26, body: 19 },
};

export const FONT_CHOICES = [
  { value: '', label: 'Theme-Standard' },
  { value: "'Fraunces', Georgia, serif", label: 'Fraunces (Serif, edel)' },
  { value: "'Manrope', system-ui, sans-serif", label: 'Manrope (Sans, modern)' },
  { value: 'Georgia, serif', label: 'Georgia (Serif, klassisch)' },
  { value: 'system-ui, -apple-system, sans-serif', label: 'System-Sans' },
];

export function resolveTypography(typo) {
  const t = typo || {};
  const base = TYPO_PRESETS[t.preset] || TYPO_PRESETS.standard;
  const num = (v, fb) => (Number(v) > 0 ? Number(v) : fb);
  return {
    preset: t.preset || 'standard',
    h1: num(t.h1, base.h1),
    h2: num(t.h2, base.h2),
    h3: num(t.h3, base.h3),
    body: num(t.body, base.body),
    font_heading: t.font_heading || '',
    font_body: t.font_body || '',
  };
}

// Fluid-Größe: skaliert von 360px bis 1200px Viewport — gut auf dem Handy.
function fluid(px) {
  const min = Math.max(13, Math.round(px * 0.66));
  if (min >= px) return `${px}px`;
  return `clamp(${min}px, calc(${min}px + (${px - min}) * ((100vw - 360px) / 840)), ${px}px)`;
}

export function typographyCss(typo, scope) {
  const t = resolveTypography(typo);
  const head = t.font_heading || "var(--shop-heading-font, 'Fraunces', Georgia, serif)";
  const body = t.font_body || "var(--shop-body-font, 'Manrope', system-ui, sans-serif)";
  const s = scope;
  return [
    // Schriftart mit Klassen-Spezifität (schlägt die Basis-Regeln in index.css);
    // Inline-Styles einzelner Blöcke gewinnen weiterhin.
    `${s} :is(h1, h2, h3, h4, h5, h6) { font-family: ${head}; }`,
    `${s} :is(p, li, blockquote, td, dd) { font-family: ${body}; }`,
    // Größen mit minimaler Spezifität — Tailwind-/Block-Klassen gewinnen.
    `:where(${s}) p, :where(${s}) li, :where(${s}) blockquote, :where(${s}) td, :where(${s}) dd { font-size: ${fluid(t.body)}; line-height: 1.75; }`,
    `:where(${s}) h1 { font-size: ${fluid(t.h1)}; line-height: 1.12; }`,
    `:where(${s}) h2 { font-size: ${fluid(t.h2)}; line-height: 1.2; }`,
    `:where(${s}) h3 { font-size: ${fluid(t.h3)}; line-height: 1.3; }`,
    `:where(${s}) h4, :where(${s}) h5, :where(${s}) h6 { font-size: ${fluid(Math.round(t.h3 * 0.88))}; line-height: 1.35; }`,
  ].join('\n');
}
